import PropTypes from 'prop-types'

import { nodePropType } from '../../common/prop-types'

const dietPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  node: nodePropType.isRequired,
  isAvailableForDishCategorization: PropTypes.bool.isRequired,
  position: PropTypes.number.isRequired,
  synonyms: PropTypes.arrayOf(PropTypes.string),
  isExcludedFromSearch: PropTypes.bool,
  isPopular: PropTypes.bool.isRequired,
})

dietPropType.defaultProps = {
  synonyms: undefined,
  isExcludedFromSearch: false,
  description: undefined,
}

export default dietPropType
